import React from 'react';

// MuzzleEarButtons — §5 其他 — 耳朵纽扣 (ear-button ×2; independent of the hood's
// bridge button color)
// MUZZLE mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function MuzzleEarButtons({ config, parts, ellipses }) {
  return (
    <>
<g id="_2102164998768">
<g>
	<ellipse className={"hood-" + config['ear-button'] + " str_222222_8"} transform={(ellipses['bridge-button_c'] || {}).transform} rx={(ellipses['bridge-button_c'] || {}).rx} ry={(ellipses['bridge-button_c'] || {}).ry}/>
	<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-22'] || ''}/>
	<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-23'] || ''}/>
</g>
<g>
	<ellipse className={"hood-" + config['ear-button'] + " str_222222_8"} transform={(ellipses['bridge-button_c_2'] || {}).transform} rx={(ellipses['bridge-button_c_2'] || {}).rx} ry={(ellipses['bridge-button_c_2'] || {}).ry}/>
	<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-24'] || ''}/>
	<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-25'] || ''}/>
</g>
</g>
    </>
  );
}

// MuzzleCheekButtons — §5 其他 — 脸颊纽扣上/下 (muzzle-button, muzzle-button-b)
// MUZZLE mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function MuzzleCheekButtons({ config, parts, ellipses }) {
  return (
    <>
<g id="_2100956552496">
<ellipse className={"hood-" + config['muzzle-button'] + " str_222222_8"} transform={(ellipses['muzzle-button_c'] || {}).transform} rx={(ellipses['muzzle-button_c'] || {}).rx} ry={(ellipses['muzzle-button_c'] || {}).ry}/>
<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-50'] || ''}/>
<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-51'] || ''}/>
<ellipse className={"hood-" + config['muzzle-button-b'] + " str_222222_8"} transform={(ellipses['muzzle-button-b_c'] || {}).transform} rx={(ellipses['muzzle-button-b_c'] || {}).rx} ry={(ellipses['muzzle-button-b_c'] || {}).ry}/>
<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-52'] || ''}/>
<path className="fil-FEFEFE" d={parts['fill-FEFEFE-path-53'] || ''}/>
</g>
    </>
  );
}
